import React, { Component } from 'react';
import { axiosInstance } from '../../utils/axiosInstance';


import { Add, Edit, Done, Close , AddCircleOutline } from '@material-ui/icons/';
import { CustomDataTable } from '../../components/UI/CustomDataTable';

import Button from '@material-ui/core/Button';
import Breadcrumbs from '@material-ui/core/Breadcrumbs';
import { Link } from "react-router-dom";
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { Delete } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';
import store from '../../store';
import swal from 'sweetalert'



export class Coupon extends Component {

    constructor(props) {
        super(props);
        this.state = {
            columns:[],            
        };

        this.dataTableRef = React.createRef();
    } 
    
    async componentDidMount() {

        const columns = [
            {
                name: 'Id',
                selector: 'id',
                sortable: true,
                width: '90px',
                hide: 'sm',

            },
            {
                name: 'Código',
                selector: 'code',
                sortable: true,
                width: '90px',

            },
            {
                name: 'Descripción',
                selector: 'description',
                sortable: true,
            },

            {
                name: 'Droguería asociada',
                selector: 'drugstoreName',
                sortable: true,
            },
            
            {
                name: 'Tipo cupón',
                selector: 'couponType',
                sortable: true,
                width: '200px',

            },


            {
                name: 'Tipo descuento',
                selector: 'couponDiscountType',
                sortable: true,
                width: '200px',

            },

            {
                name: 'Válido desde',
                selector: 'validFrom',
                sortable: true,
                width: '150px',

            },

            {
                name: 'Válido hasta',
                selector: 'validUntil',
                sortable: true,
                width: '150px',

            },
            {
                name: '% de descuento',
                selector: 'discountPercentage',
                sortable: true,
                width: '150px',

            },

            {
                name: 'Monto fijo',
                selector: 'discountFixedAmount',
                sortable: true,
                width: '150px',

            },

            {
                name: 'Habilitado',
                selector: 'enabled',
                sortable: true,
                cell: d => d.enabled === true ? <Done style={{ color: 'green' }} /> : <Close style={{ color: 'red' }} />,
                width: '90px',

            },

   
          
            {
                name: 'Opciones',
                button: true,
                cell: row =>
                    <Link to={"/editando-cupon/" + row.id}>
                        <Tooltip title="Editar">
                            <IconButton aria-label="Editar">
                                <Edit />
                            </IconButton>
                        </Tooltip>
                    </Link>
                ,
                allowOverflow: true,
                width: '60px',
            },       
            {
                cell: row =>
                    <Tooltip title="Eliminar">
                        <IconButton
                            aria-label="delete"
                            onClick={this.handleDeleteClick}
                            data-row_id={row.id}
                            data-row_text={row.CouponTypeName}>
                            <Delete color="error" />
                        </IconButton>
                    </Tooltip>
                ,
                ignoreRowClick: true,
                allowOverflow: true,
                button: true,
                width: '60px',
            },
        ];

        this.setState({
            columns: columns,                              
        });

      
    }

    

    handleDeleteClick = async e =>{

 

        var id = e.currentTarget.dataset.row_id;
        var text = e.currentTarget.dataset.row_text;

        const deleteRow = await swal({
            title: "¿Confirma la operación?",
            text: text,
            icon: "warning",
            dangerMode: true,
            buttons: true,

        });

        if (deleteRow) {
            await axiosInstance.delete('api/Coupon/delete/' + id)
                .then(response => {

                     swal("Se eliminó el registro", {
                            icon: "success",
                        });
                    this.dataTableRef.current.refreshDataTable();

                }).catch(error => {

                    swal({
                        icon: 'error',
                        title: 'Oops, algo sucedió...',
                        text: error.response.data.message
                    })

                });
        }
    }

    onChange = (event, value) => {
        this.setState({
            [event.target.name]: event.target.value
        })
    }

    onSubmit = e => {
        console.log("submiting");
        e.preventDefault();
    }

    render() {
      
        return (
            <div>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={7} md={7} lg={9}>
                        <h4>
                            Cupones
                            <small >
                                <Breadcrumbs aria-label="breadcrumb">
                                    <Typography color="inherit">
                                        Precios y ofertas
                                </Typography>
                                    <Typography color="textPrimary">Cupones</Typography>
                                </Breadcrumbs>
                            </small>
                        </h4>
                    </Grid>
                    <Grid item xs={12} sm={5} md={5} lg={3}>
                        
                        <Link to="/nuevo-cupon">
                            <Button variant="contained" color="primary" startIcon={<AddCircleOutline />} style={{ float: 'right', width:'100%' }}>
                                Nuevo cupón
                        </Button>
                        </Link>
                        
                    </Grid>
                </Grid>

                <hr/>

                <CustomDataTable
                    url="api/Coupon"
                    columns={this.state.columns}
                    handleOpenModal={this.handleOpenModal}
                    ref={this.dataTableRef}
                    showHeader={true}
                />
            </div>
        );
    }
}
